export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const DAYS = ['M', 'T', 'W', 'Th', 'F', 'S', 'Su'];

export const getDaysInMonth = (year, month) => {
  return new Date(year, month + 1, 0).getDate();
};

export const getFirstDayOfMonth = (year, month) => {
  const firstDay = new Date(year, month, 1).getDay();
  return firstDay === 0 ? 6 : firstDay - 1; // Convert Sunday (0) to 6, Monday (1) to 0, etc.
};

export const getPreviousMonthDays = (year, month) => {
  const firstDay = getFirstDayOfMonth(year, month);
  const prevMonth = month === 0 ? 11 : month - 1;
  const prevYear = month === 0 ? year - 1 : year;
  const daysInPrevMonth = getDaysInMonth(prevYear, prevMonth);

  const days = [];
  for (let i = firstDay - 1; i >= 0; i--) {
    days.push(daysInPrevMonth - i);
  }
  return days;
};

export const getNextMonthDays = (year, month) => {
  const daysInMonth = getDaysInMonth(year, month);
  const firstDay = getFirstDayOfMonth(year, month);
  const totalCells = 42; // 6 rows × 7 days
  const remainingCells = totalCells - (firstDay + daysInMonth);

  const days = [];
  for (let i = 1; i <= remainingCells; i++) {
    days.push(i);
  }
  return days;
};

export const formatDate = (date) => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const isSameDate = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
};

export const isToday = (date) => {
  return isSameDate(date, new Date());
};

export const formatTimeTo12Hour = (timeString) => {
  if (!timeString || timeString === "XX:XX") return "XX:XX";

  try {
    // Handle various input formats like "13:45:00", "13:45", "1:45pm", etc.
    const timeParts = timeString.split(':');
    let hours = parseInt(timeParts[0]);
    let minutes = timeParts[1] ? parseInt(timeParts[1].split(/[^\d]/)[0]) : 0;

    const period = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12 for 12 AM

    return `${hours}:${minutes.toString().padStart(2, '0')}${period}`;
  } catch (error) {
    console.error('Error formatting time:', error);
    return timeString; // Return original string if formatting fails
  }
};
